import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '@/portal/auth/AuthContext';
import { ApiError } from '@/portal/api/client';

const LOGO = '/assets/didiers-logo.svg';

export function AcceptInvitePage() {
  const { token = '' } = useParams();
  const { acceptInvite } = useAuth();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (busy) return;
    setError(null);
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setBusy(true);
    try {
      await acceptInvite(token, password);
      navigate('/portal', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not redeem this invite.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="portal">
      <div className="pl-login">
        <form className="pl-login-card" onSubmit={onSubmit}>
          <div className="pl-login-head">
            <img src={LOGO} alt="Didier's Patisserie" />
          </div>
          <div className="pl-login-body">
            <h1>Set your password</h1>
            <p className="sub">Choose a password to activate your Client &amp; Trade Portal account.</p>

            {error && <div className="pl-login-error">{error}</div>}

            <div className="pl-field">
              <label htmlFor="pl-new">New password</label>
              <input
                id="pl-new"
                type="password"
                autoComplete="new-password"
                placeholder="At least 8 characters"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="pl-field">
              <label htmlFor="pl-confirm">Confirm password</label>
              <input
                id="pl-confirm"
                type="password"
                autoComplete="new-password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="pl-btn dark"
              style={{ width: '100%', justifyContent: 'center', padding: '12px' }}
              disabled={busy}
            >
              {busy ? 'Activating…' : 'Activate account'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
